import React from 'react';
import { Link } from 'react-router-dom';
import styles from './WebsiteFooter.module.css';

const socialLinks = [
  { name: 'Facebook', icon: '/assets/website/icon-facebook.svg', href: 'https://facebook.com/ogiso' },
  { name: 'Instagram', icon: '/assets/website/icon-instagram.svg', href: 'https://instagram.com/ogiso' },
  { name: 'X', icon: '/assets/website/icon-x.svg', href: 'https://x.com/ogiso' },
  { name: 'LinkedIn', icon: '/assets/website/icon-linkedin.svg', href: 'https://linkedin.com/company/ogiso' },
  { name: 'Youtube', icon: '/assets/website/icon-youtube.svg', href: 'https://youtube.com/@ogiso' },
];

const productLinks = [
  { label: 'Features', href: '/#features' },
  { label: 'eMAR', href: '/#emar' },
  { label: 'Task Management', href: '/#task' },
  { label: 'Progress Notes', href: '/#notes' },
  { label: 'Reporting', href: '/#reporting' },
  { label: 'Pricing', href: '/pricing' },
];

const companyLinks = [
  { label: 'Contact', href: '/contact-us' },
  { label: 'Book a Demo', href: '/book-demo' },
  { label: 'Login', href: '/login' },
];

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Cookie Policy', href: '/cookies-policy' },
  { label: 'Terms of Service', href: '/term-conditions' },
];

const WebsiteFooter = () => {
  const currentYear = new Date().getFullYear();

  const renderLink = (link, className) => {
    if (link.href.includes('#')) {
      return (
        <a key={link.label} href={link.href} className={className}>
          {link.label}
        </a>
      );
    }
    return (
      <Link key={link.label} to={link.href} className={className}>
        {link.label}
      </Link>
    );
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        <div className={styles.footer__content}>
          <div className={`${styles.footer__column} ${styles['footer__column--info']}`}>
            <div className={styles.footer__logo}>
              <img src="/assets/website/footer-logo.png" alt="Ogiso" width="179" height="66" />
            </div>

            <div className={styles.footer__info}>
              <div className={styles['footer__info-block']}>
                <p className={styles['footer__info-label']}>Address:</p>
                <p className={styles['footer__info-text']}>2436 West Tonto St, Phoenix, AZ 85009</p>
              </div>
              <div className={styles['footer__info-block']}>
                <p className={styles['footer__info-label']}>Contact:</p>
                <div className={styles['footer__info-links']}>
                  <a href="tel:+17576000297" className={styles['footer__info-link']}>+1 757-600-0297</a>
                  <a href="mailto:support@ogiso.io" className={styles['footer__info-link']}>support@ogiso.io</a>
                </div>
              </div>
            </div>

            <div className={styles.footer__social}>
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className={styles['footer__social-link']}
                  aria-label={social.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={social.icon} alt="" width="24" height="24" />
                </a>
              ))}
            </div>
          </div>

          <div className={`${styles.footer__column} ${styles['footer__column--links']}`}>
            <div className={styles['footer__links-group']}>
              <h4 className={styles['footer__links-title']}>Product</h4>
              <div className={styles['footer__links-list']}>
                {productLinks.map((link) => renderLink(link, styles.footer__link))}
              </div>
            </div>
            <div className={styles['footer__links-group']}>
              <h4 className={styles['footer__links-title']}>Company</h4>
              <div className={styles['footer__links-list']}>
                {companyLinks.map((link) => renderLink(link, styles.footer__link))}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.footer__credits}>
          <div className={styles.footer__divider}></div>
          <div className={styles.footer__bottom}>
            <p className={styles.footer__copyright}>&copy; {currentYear} Ogiso. All rights reserved.</p>
            <div className={styles.footer__legal}>
              {legalLinks.map((link) => (
                <Link key={link.label} to={link.href} className={styles['footer__legal-link']}>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
